var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vx-card", { staticClass: "cursor-pointer" }, [
    _vm.data.image_path
      ? _c("img", {
          staticClass: "mx-auto mb-4 responsive",
          attrs: { src: _vm.data.image_path, alt: "graphic" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("h4", { staticClass: "mb-2" }, [
      _vm._v(_vm._s(_vm.data.name.toUpperCase()))
    ]),
    _vm._v(" "),
    _c("small", { staticClass: "text-center" }, [
      _vm._v(_vm._s(_vm.$t("helpCenter.groupDesc", [_vm.data.name])))
    ]),
    _vm._v(" "),
    _vm.showArticles
      ? _c(
          "ul",
          { staticClass: "bordered-items mt-4" },
          _vm._l(_vm.data.articles, function(que) {
            return _c(
              "li",
              {
                key: que.slug,
                staticClass: "py-2",
                on: {
                  click: function($event) {
                    return _vm.onClickArticle(que)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(que.title) + "\n        ")]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }